export class TemplateDto {
    constructor(id, template, name, type, active, authorized, contentSidTwilio, nameTemplateTwilio ) {
        this.id = id;
        this.template = template;
        this.name = name;
        this.type = type;
        this.active = active;
        this.authorized = authorized;
        this.contentSidTwilio = contentSidTwilio;
        this.nameTemplateTwilio = nameTemplateTwilio;
    }
}